import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "pub-header" }
const _hoisted_2 = { class: "pub-header-left" }
const _hoisted_3 = { class: "pub-header-titles" }
const _hoisted_4 = { class: "pub-system-name" }
const _hoisted_5 = { class: "pub-project-name" }
const _hoisted_6 = { class: "pub-header-right" }
const _hoisted_7 = { class: "pub-badge" }
const _hoisted_8 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  style: {"flex-shrink":"0"}
}
const _hoisted_9 = {
  key: 0,
  class: "pub-expiry"
}
const _hoisted_10 = {
  key: 0,
  class: "pub-state"
}
const _hoisted_11 = {
  key: 1,
  class: "pub-state pub-state--error"
}
const _hoisted_12 = { class: "pub-toolbar" }
const _hoisted_13 = { class: "pz-group" }
const _hoisted_14 = { class: "pz-scale-val" }
const _hoisted_15 = {
  class: "export-wrap",
  ref: "exportMenuRef"
}
const _hoisted_16 = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  style: {"margin-left":"2px"}
}
const _hoisted_17 = {
  key: 0,
  class: "planning-body"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "label-meta" }
const _hoisted_21 = { class: "label-progress-wrap" }
const _hoisted_22 = { class: "label-progress-track" }
const _hoisted_23 = { class: "label-progress-pct" }
const _hoisted_24 = {
  class: "header-groups",
  style: {"height":"26px"}
}
const _hoisted_25 = {
  class: "header-days",
  style: {"height":"26px"}
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "bar-center-pct" }
const _hoisted_29 = ["d"]
const _hoisted_30 = {
  key: 1,
  class: "pub-state"
}
const _hoisted_31 = {
  key: 2,
  class: "pub-undated"
}
const _hoisted_32 = { class: "pub-undated-header" }
const _hoisted_33 = { class: "pub-undated-count" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "pub-undated-info" }
const _hoisted_36 = ["title"]
const _hoisted_37 = { class: "pub-undated-meta" }
const _hoisted_38 = { class: "pub-undated-progress" }
const _hoisted_39 = { class: "pub-undated-progress-track" }
const _hoisted_40 = { class: "pub-undated-pct" }
const _hoisted_41 = { class: "pub-footer" }
const _hoisted_42 = { class: "task-modal" }
const _hoisted_43 = { class: "task-modal-title" }
const _hoisted_44 = { class: "task-modal-body" }
const _hoisted_45 = { class: "task-modal-progress" }
const _hoisted_46 = { class: "task-modal-progress-track" }
const _hoisted_47 = { class: "task-modal-pct-label" }
const _hoisted_48 = { class: "task-modal-info" }
const _hoisted_49 = {
  key: 0,
  class: "task-info-row"
}
const _hoisted_50 = { class: "task-info-row" }
const _hoisted_51 = { class: "task-info-val" }
const _hoisted_52 = { class: "task-info-row" }
const _hoisted_53 = { class: "task-info-val" }
const _hoisted_54 = {
  key: 2,
  class: "task-info-row"
}
const _hoisted_55 = { class: "task-info-val" }
const _hoisted_56 = {
  key: 3,
  class: "task-info-row task-info-row--block"
}
const _hoisted_57 = { class: "task-info-val" }
const _hoisted_58 = {
  key: 4,
  class: "task-info-row task-info-row--block"
}
const _hoisted_59 = { class: "task-info-tags" }
const _hoisted_60 = {
  key: 0,
  class: "task-modal-last-update"
}
const _hoisted_61 = { class: "task-last-update-line" }
const _hoisted_62 = { class: "task-last-update-date" }
const _hoisted_63 = {
  key: 0,
  class: "task-last-update-note"
}
const _hoisted_64 = {
  key: 1,
  class: "task-modal-history"
}
const _hoisted_65 = { class: "task-history-date" }
const _hoisted_66 = {
  key: 0,
  class: "task-history-note"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "public-shell",
    style: _normalizeStyle(_ctx.cssVars),
    onMousemovePassive: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onMouseMove && _ctx.onMouseMove(...args))),
    onMouseup: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args))),
    onMouseleave: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args))),
    onTouchmovePassive: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onTouchMove && _ctx.onTouchMove(...args))),
    onTouchend: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onTouchEnd && _ctx.onTouchEnd(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "pub-logo-mark" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.systemName || 'Obra Tycoon'), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.projectTitle), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, [
          (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("circle", {
              cx: "6",
              cy: "4.5",
              r: "2.2",
              stroke: "currentColor",
              "stroke-width": "1.2"
            }, null, -1),
            _createElementVNode("path", {
              d: "M2 11c0-2.21 1.79-4 4-4s4 1.79 4 4",
              stroke: "currentColor",
              "stroke-width": "1.2",
              "stroke-linecap": "round"
            }, null, -1)
          ]))])),
          _cache[21] || (_cache[21] = _createTextVNode(" Somente leitura ", -1))
        ]),
        (_ctx.expiresAt)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Válido até " + _toDisplayString(_ctx.formatExpiry(_ctx.expiresAt)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[22] || (_cache[22] = [
          _createElementVNode("div", { class: "pub-spinner" }, null, -1),
          _createElementVNode("p", null, "Carregando diagrama…", -1)
        ]))]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[23] || (_cache[23] = _createElementVNode("svg", {
              width: "40",
              height: "40",
              viewBox: "0 0 40 40",
              fill: "none"
            }, [
              _createElementVNode("circle", {
                cx: "20",
                cy: "20",
                r: "18",
                stroke: "currentColor",
                "stroke-width": "2"
              }),
              _createElementVNode("path", {
                d: "M20 12v10M20 27v2",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round"
              })
            ], -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  class: _normalizeClass(["pz-btn", { active: _ctx.zoom === 'day' }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setZoom('day')))
                }, "Dia", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["pz-btn", { active: _ctx.zoom === 'week' }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setZoom('week')))
                }, "Semana", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["pz-btn", { active: _ctx.zoom === 'month' }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setZoom('month')))
                }, "Mês", 2),
                _createElementVNode("button", {
                  class: "pz-btn",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.scrollToToday && _ctx.scrollToToday(...args)))
                }, "Hoje")
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                min: "25",
                max: "350",
                step: "5",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.zoomScale) = $event)),
                class: "pz-scale"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.zoomScale,
                  void 0,
                  { number: true }
                ]
              ]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.zoomScale) + "%", 1),
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "pub-toolbar-sep" }, null, -1)),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: _normalizeClass(["pub-export-btn", { active: _ctx.showExportMenu }]),
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.showExportMenu = !_ctx.showExportMenu), ["stop"]))
                }, [
                  _cache[25] || (_cache[25] = _createElementVNode("svg", {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 13 13",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M6.5 1v7M4 5.5l2.5 2.5L9 5.5M2 10h9",
                      stroke: "currentColor",
                      "stroke-width": "1.4",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)),
                  _cache[26] || (_cache[26] = _createTextVNode(" Exportar ", -1)),
                  (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("path", {
                      d: "M2 3.5l3 3 3-3",
                      stroke: "currentColor",
                      "stroke-width": "1.4",
                      "stroke-linecap": "round"
                    }, null, -1)
                  ]))]))
                ], 2),
                (_ctx.showExportMenu)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "pub-export-dropdown",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("button", {
                        class: "pub-export-option",
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.exportGanttExcel(); _ctx.showExportMenu = false})
                      }, [...(_cache[27] || (_cache[27] = [
                        _createElementVNode("span", {
                          class: "pub-export-icon",
                          style: {"background":"#e8f5ee","color":"#107C41"}
                        }, [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 16 16",
                            fill: "none"
                          }, [
                            _createElementVNode("rect", {
                              width: "16",
                              height: "16",
                              rx: "3",
                              fill: "#107C41"
                            }),
                            _createElementVNode("path", {
                              d: "M4 6.5l1.5 3L7 6.5M9.5 6.5v3M9.5 9h2",
                              stroke: "white",
                              "stroke-width": "1.2",
                              "stroke-linecap": "round"
                            })
                          ])
                        ], -1),
                        _createTextVNode(" Excel (.xlsx) ", -1)
                      ]))]),
                      _createElementVNode("button", {
                        class: "pub-export-option",
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.exportGantt(); _ctx.showExportMenu = false})
                      }, [...(_cache[28] || (_cache[28] = [
                        _createStaticVNode("<span class=\"pub-export-icon\" style=\"background:#fce8e8;color:#C00000;\" data-v-4b507f2a><svg width=\"14\" height=\"14\" viewBox=\"0 0 16 16\" fill=\"none\" data-v-4b507f2a><rect width=\"16\" height=\"16\" rx=\"3\" fill=\"#C00000\" data-v-4b507f2a></rect><path d=\"M4 3h5l3 3v7H4V3z\" fill=\"white\" opacity=\".15\" data-v-4b507f2a></path><path d=\"M9 3v3h3M5.5 9h5M5.5 11h3\" stroke=\"white\" stroke-width=\"1.2\" stroke-linecap=\"round\" data-v-4b507f2a></path></svg></span> PDF / Imprimir ", 2)
                      ]))])
                    ]))
                  : _createCommentVNode("", true)
              ], 512)
            ]),
            (_ctx.datedRows.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: "gantt-labels",
                    ref: "labelsRef",
                    style: _normalizeStyle({ width: _ctx.labelsWidth + 'px', minWidth: _ctx.labelsWidth + 'px' })
                  }, [
                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "label-header" }, [
                      _createElementVNode("span", { class: "label-header-title" }, "Tarefa"),
                      _createElementVNode("span", { class: "label-header-progress" }, "%")
                    ], -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datedRows, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: row.id,
                        class: "label-row",
                        style: _normalizeStyle({ height: _ctx.rowH + 'px' }),
                        onClick: ($event: any) => (_ctx.openTask(row))
                      }, [
                        _createElementVNode("div", {
                          class: "label-name",
                          title: row.title
                        }, _toDisplayString(row.title), 9, _hoisted_19),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(row.assigneeName || row.assigneeUsername), 1),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", {
                              class: "label-progress-fill",
                              style: _normalizeStyle({ width: _ctx.latestPct(row) + '%', background: row.color || _ctx.accentColor })
                            }, null, 4)
                          ]),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.latestPct(row)) + "%", 1)
                        ])
                      ], 12, _hoisted_18))
                    }), 128))
                  ], 4),
                  _createElementVNode("div", {
                    class: "label-resize-handle",
                    onMousedown: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startLabelResize && _ctx.startLabelResize(...args)), ["stop","prevent"])),
                    onTouchstart: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startLabelResizeTouch && _ctx.startLabelResizeTouch(...args)), ["stop","prevent"]))
                  }, null, 32),
                  _createElementVNode("div", {
                    class: "gantt-scroll",
                    ref: "scrollRef",
                    onScroll: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.syncScroll && _ctx.syncScroll(...args)))
                  }, [
                    _createElementVNode("div", {
                      class: "timeline",
                      style: _normalizeStyle({ width: _ctx.totalWidth + 'px' })
                    }, [
                      _createElementVNode("div", {
                        class: "timeline-header",
                        style: _normalizeStyle({ width: _ctx.totalWidth + 'px' })
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerGroups, (g) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: g.key,
                              class: "header-group",
                              style: _normalizeStyle({ left: g.leftPx + 'px', width: g.widthPx + 'px' })
                            }, _toDisplayString(g.label), 5))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerDays, (d) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: d.key,
                              class: _normalizeClass(["header-day", { weekend: d.isWeekend, today: d.isToday }]),
                              style: _normalizeStyle({ width: _ctx.dayPx + 'px' })
                            }, _toDisplayString(d.label), 7))
                          }), 128))
                        ])
                      ], 4),
                      _createElementVNode("div", {
                        class: "timeline-body",
                        style: _normalizeStyle({ width: _ctx.totalWidth + 'px', height: (_ctx.datedRows.length * _ctx.rowH) + 'px' })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekendDays, (d) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'we-' + d.key,
                            class: "col-weekend",
                            style: _normalizeStyle({ left: d.leftPx + 'px', width: _ctx.dayPx + 'px', height: (_ctx.datedRows.length * _ctx.rowH) + 'px' })
                          }, null, 4))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blockedDayCells, (d) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'blk-' + d.key,
                            class: "col-blocked",
                            style: _normalizeStyle({ left: d.leftPx + 'px', width: _ctx.dayPx + 'px', height: (_ctx.datedRows.length * _ctx.rowH) + 'px' })
                          }, null, 4))
                        }), 128)),
                        (_ctx.todayX !== null)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "today-line",
                              style: _normalizeStyle({ left: _ctx.todayX + 'px', height: (_ctx.datedRows.length * _ctx.rowH) + 'px' })
                            }, [...(_cache[31] || (_cache[31] = [
                              _createElementVNode("span", { class: "today-label" }, "Hoje", -1)
                            ]))], 4))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datedRows, (row, ri) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'bar-' + row.id,
                            class: "track-row",
                            style: _normalizeStyle({ top: (ri * _ctx.rowH) + 'px', height: _ctx.rowH + 'px' }),
                            onClick: ($event: any) => (_ctx.openTask(row))
                          }, [
                            (_ctx.barStyle(row))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "bar",
                                  style: _normalizeStyle(_ctx.barStyle(row)),
                                  title: row.title
                                }, [
                                  _createElementVNode("div", {
                                    class: "bar-progress",
                                    style: _normalizeStyle({ width: _ctx.latestPct(row) + '%' })
                                  }, null, 4),
                                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.latestPct(row)) + "%", 1)
                                ], 12, _hoisted_27))
                              : _createCommentVNode("", true)
                          ], 12, _hoisted_26))
                        }), 128)),
                        (_openBlock(), _createElementBlock("svg", {
                          class: "deps-svg",
                          style: _normalizeStyle({ width: _ctx.totalWidth + 'px', height: (_ctx.datedRows.length * _ctx.rowH) + 'px' })
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depLines, (dep) => {
                            return (_openBlock(), _createElementBlock("g", {
                              key: dep.key
                            }, [
                              _createElementVNode("path", {
                                d: dep.d,
                                fill: "none",
                                stroke: "rgba(0,0,0,0.2)",
                                "stroke-width": "1.5",
                                "stroke-dasharray": "4 3",
                                "marker-end": "url(#pub-arr)"
                              }, null, 8, _hoisted_29)
                            ]))
                          }), 128)),
                          _cache[32] || (_cache[32] = _createElementVNode("defs", null, [
                            _createElementVNode("marker", {
                              id: "pub-arr",
                              markerWidth: "6",
                              markerHeight: "6",
                              refX: "3",
                              refY: "3",
                              orient: "auto"
                            }, [
                              _createElementVNode("path", {
                                d: "M0,0 L0,6 L6,3 z",
                                fill: "rgba(0,0,0,0.25)"
                              })
                            ])
                          ], -1))
                        ], 4))
                      ], 4)
                    ], 4)
                  ], 544)
                ]))
              : _createCommentVNode("", true),
            (_ctx.rows.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[33] || (_cache[33] = [
                  _createElementVNode("p", null, "Nenhuma tarefa encontrada neste planejamento.", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.undatedRows.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[34] || (_cache[34] = _createElementVNode("span", { class: "pub-undated-title" }, "Sem data definida", -1)),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.undatedRows.length), 1),
                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "pub-undated-hint" }, "atividades aguardando agendamento", -1))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.undatedRows, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'nd-' + row.id,
                      class: "pub-undated-row",
                      onClick: ($event: any) => (_ctx.openTask(row))
                    }, [
                      _createElementVNode("span", {
                        class: "pub-undated-dot",
                        style: _normalizeStyle({ background: row.color || _ctx.accentColor })
                      }, null, 4),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", {
                          class: "pub-undated-name",
                          title: row.title
                        }, _toDisplayString(row.title), 9, _hoisted_36),
                        _createElementVNode("div", _hoisted_37, _toDisplayString(row.assigneeName || row.assigneeUsername), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", {
                            class: "pub-undated-progress-fill",
                            style: _normalizeStyle({ width: _ctx.latestPct(row) + '%', background: row.color || _ctx.accentColor })
                          }, null, 4)
                        ]),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.latestPct(row)) + "%", 1)
                      ])
                    ], 8, _hoisted_34))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64)),
    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.logoText) + "  ·  Visualização somente leitura ", 1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.selectedTask)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "task-modal-backdrop",
            onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.selectedTask = null), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", {
                class: "task-modal-header",
                style: _normalizeStyle({ borderLeftColor: _ctx.selectedTask.color || _ctx.accentColor })
              }, [
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.selectedTask.title), 1),
                _createElementVNode("button", {
                  class: "task-modal-close",
                  type: "button",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedTask = null))
                }, "✕")
              ], 4),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", {
                      class: "task-modal-progress-fill",
                      style: _normalizeStyle({ width: _ctx.latestPct(_ctx.selectedTask) + '%', background: _ctx.selectedTask.color || _ctx.accentColor })
                    }, null, 4)
                  ]),
                  _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.latestPct(_ctx.selectedTask)) + "%", 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  (_ctx.isUndatedRow(_ctx.selectedTask))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [...(_cache[36] || (_cache[36] = [
                        _createElementVNode("span", { class: "task-info-label" }, "Datas", -1),
                        _createElementVNode("span", {
                          class: "task-info-val",
                          style: {"color":"#9a6b00","font-weight":"700"}
                        }, "Sem data definida", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_50, [
                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "task-info-label" }, "Início", -1)),
                          _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.formatDate(_ctx.selectedTask.plannedStart)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _cache[38] || (_cache[38] = _createElementVNode("span", { class: "task-info-label" }, "Término", -1)),
                          _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.formatDate(_ctx.selectedTask.plannedEnd)), 1)
                        ])
                      ], 64)),
                  (_ctx.selectedTask.assigneeUsername)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "task-info-label" }, "Responsável", -1)),
                        _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.selectedTask.assigneeName || _ctx.selectedTask.assigneeUsername), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTask.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "task-info-label" }, "Descrição", -1)),
                        _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.selectedTask.description), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTask.dependencyTaskIds?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "task-info-label" }, "Dependências", -1)),
                        _createElementVNode("div", _hoisted_59, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTask.dependencyTaskIds, (depId) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: depId,
                              class: "task-info-tag"
                            }, _toDisplayString(_ctx.rows.find(r => r.id === depId)?.title || depId), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.selectedLastUpdate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _cache[42] || (_cache[42] = _createElementVNode("p", { class: "task-modal-history-title" }, "Última atualização", -1)),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("strong", {
                          class: "task-last-update-pct",
                          style: _normalizeStyle({ color: _ctx.selectedTask.color || _ctx.accentColor })
                        }, _toDisplayString(_ctx.selectedLastUpdate.progressPercent ?? 0) + "%", 5),
                        _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.formatDate(_ctx.selectedLastUpdate.progressDate)), 1)
                      ]),
                      (_ctx.selectedLastUpdate.notes)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(_ctx.selectedLastUpdate.notes), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedTask.progressUpdates?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _cache[43] || (_cache[43] = _createElementVNode("p", { class: "task-modal-history-title" }, "Histórico de progresso", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._ctx.selectedTask.progressUpdates].reverse(), (upd, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: upd.id || i,
                          class: "task-history-item"
                        }, [
                          _createElementVNode("span", {
                            class: "task-history-pct",
                            style: _normalizeStyle({ color: _ctx.selectedTask.color || _ctx.accentColor })
                          }, _toDisplayString(upd.progressPercent ?? 0) + "%", 5),
                          _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.formatDate(upd.progressDate)), 1),
                          (upd.notes)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(upd.notes), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 36))
}